import { Button, Chip, Pagination } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getPublicationColor } from "../../../../config/publicationColors.js";
import { getCookie } from "../../../../function.js";
import getArticleService from "../../../../services/getArticleService";
import { getPaymentStatus } from "../../../../utils/paymentStatus";
import DeleteConfirm from "../../adminComponents/DeleteConfirm";
import PaymentVerify from "../../adminComponents/PaymentVerify";
import ViewPaymentProof from "../viewPaymentProof";
import ViewPdf from "../viewPdf";

const columns = [
  { id: "id", label: "Article Id", minWidth: 120, align: "center" },
  { id: "name", label: "User Name", minWidth: 150, align: "center" },
  { id: "date", label: "Date of Payment", minWidth: 150, align: "center" },
  { id: "date", label: "Last Modified", minWidth: 150, align: "center" },

  { id: "Journal Name", label: "Journal Name", minWidth: 250, align: "center" },
  {
    id: "Publication Name",
    label: "Publication Name",
    minWidth: 200,
    align: "center",
  },

  {
    id: "Email id",
    label: "Payer EmailId",
    minWidth: 150,
    align: "center",
  },

  {
    id: "Payment Status",
    label: "Payment Status",
    minWidth: 200,
    align: "center",
  },
  {
    id: "Payment Proof",
    label: "Payment Proof",
    minWidth: 270,
    align: "center",
  },

  {
    id: "Action",
    label: "Action",
    minWidth: 250,
    align: "center",
  },
];

function Row(props) {
  const { row, fetchData, setSelectedRow, setOpenViewImage, setSelectFileRow } =
    props;
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [isOpenPdf, setIsOpenPdf] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [isOpenView, setIsOpenView] = useState(false);
  const [articleData, setArticleData] = useState(null);

  const [token, setToken] = useState(getCookie("token"));
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRowDelete, setSelectedRowDelete] = useState({});

  const decodedToken = token ? jwtDecode(token) : null;

  const handleArticleIdClick = (id) => {
    navigate(`/admin/single-article/${id}`);
  };

  const viewPaymentProof = (val) => {
    setArticleData(val);
    setIsOpenView(true);
  };

  const handleClickDelete = (row) => {
    setSelectedRowDelete(row);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      const list = await getArticleService.DeleteArticle(selectedRowDelete.id);
      fetchData();
      setOpenDelete(false);
    } catch (error) {
      console.error("Error deleting article:", error);
    }
  };

  useEffect(() => {
    if (row.id === articleData?.id) {
      setArticleData(row);
    }
  }, [row]);

  const paymentStatus = getPaymentStatus(row);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          <Button
            variant="text"
            onClick={() => handleArticleIdClick(row.id)}
            sx={{
              textTransform: "none",
              color: "primary.main",
              "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            }}
          >
            {row.id}
          </Button>
        </TableCell>
        <TableCell align="center">
          {row.clientDetails?.first_name ||
            "" + " " + row.clientDetails?.last_name ||
            ""}
        </TableCell>
        <TableCell align="center">
          {moment(row.dateofPayment).format("DD-MM-YYYY")}
        </TableCell>

        <TableCell align="center">
          {moment(row.modifiedAt).format("DD-MM-YYYY")}
        </TableCell>

        <TableCell align="center">{row.journalName}</TableCell>
        <TableCell align="center">
          <Badge
            bg={getPublicationColor(row.publicationDetails?.name)}
            style={{
              fontSize: "16px",
              backgroundColor: getPublicationColor(
                row.publicationDetails?.name
              ),
              color: "#fff",
              padding: "8px 16px",
              borderRadius: "20px",
              fontWeight: "600",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              textTransform: "capitalize",
            }}
          >
            {row.publicationDetails?.name}
          </Badge>
        </TableCell>
        <TableCell align="center">{row.emailId}</TableCell>

        <TableCell align="center">
          <Chip
            label={paymentStatus.label}
            color={paymentStatus.color}
            size="medium"
            sx={{
              fontWeight: 500,
              minWidth: "120px",
            }}
          />
        </TableCell>
        <TableCell align="center">
          {row.payments && row.payments.length > 0 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => viewPaymentProof(row)}
            >
              View Proof
            </Button>
          ) : (
            <span>No Proof</span>
          )}
        </TableCell>

        <TableCell align="center">
          <Button
            variant="contained"
            className="ms-2"
            color="secondary"
            size="small"
            onClick={() => handleClickDelete(row)}
          >
            Delete
          </Button>
        </TableCell>
      </TableRow>
      <DeleteConfirm
        openDelete={openDelete}
        handleDelete={handleDelete}
        handleClose={() => setOpenDelete(false)}
      />
      <ViewPdf
        isOpenPdf={isOpenPdf}
        setIsOpenPdf={setIsOpenPdf}
        pdfData={pdfData}
      />
      <ViewPaymentProof
        isOpenView={isOpenView}
        setIsOpenView={setIsOpenView}
        articleData={articleData}
        reFetchData={fetchData}
      />
    </React.Fragment>
  );
}

const List = ({ getdata, fetchData, filterVal, setFilterVal }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedRow, setSelectedRow] = useState("");
  const [openViewImage, setOpenViewImage] = useState(false);
  const [selectFileRow, setSelectFileRow] = useState();

  const fetchPreSignedUrl = async () => {
    const filterVal = {
      key: selectFileRow?.file,
    };
    try {
      const data = await getArticleService.getFilePreSIgnedUrl(filterVal);
      setSelectFileRow();

      if (data) {
        const link = document.createElement("a");
        link.href = data;
        link.click();
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    if (selectFileRow?.file) {
      fetchPreSignedUrl();
    }
  }, [selectFileRow?.file]);

  const handleChangePage = (event, newPage) => {
    setFilterVal({ ...filterVal, pageNumber: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseViewImage = () => {
    setOpenViewImage(false);
  };

  const handleVerifyPayment = async () => {
    let data = {
      paymentStatus: !selectedRow.paymentStatus,
    };
    try {
      const list = await getArticleService.UpdateArticle(data, selectedRow.id);
      fetchData();
      setOpenViewImage(false);
    } catch (error) {
      console.error("Error updating payment status:", error);
    }
  };

  return (
    <Paper sx={{ width: "100%", boxShadow: "none", height: "100%" }}>
      <TableContainer sx={{ minHeight: "62vh", maxHeight: "62vh" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {getdata.map((row) => (
              <Row
                key={row.id}
                row={row}
                setSelectFileRow={setSelectFileRow}
                setSelectedRow={setSelectedRow}
                setOpenViewImage={setOpenViewImage}
                fetchData={fetchData}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex justify-content-end mt-3 mb-3 px-4">
        <Pagination
          page={filterVal.pageNumber}
          onChange={handleChangePage}
          count={filterVal.totalPages}
          variant="outlined"
          color="primary"
        />
      </div>
      <PaymentVerify
        selectedRow={selectedRow}
        openViewImage={openViewImage}
        handleVerifyPayment={handleVerifyPayment}
        handleCloseViewImage={handleCloseViewImage}
      />
    </Paper>
  );
};

export default List;
